module.exports = __webpack_public_path__ + "static/media/xenopus_tropicalis.98271459.svg";